module.exports = __webpack_public_path__ + "d136e80b15c4c358b4a1428e017f4a4f.svg";